// extracted by mini-css-extract-plugin
export var background = "_6f-0";
export var container = "_6f-1";
export var contentItem = "_6f-7";
export var extendedWarranty = "_6f-5";
export var link = "_6f-d";
export var modal = "_6f-b";
export var modalCloseButton = "_6f-9";
export var modalContent = "_6f-3";
export var modalContentMain = "_6f-6";
export var modalImageLogo = "_6f-8";
export var modalLogo = "_6f-a";
export var modalSideImage = "_6f-4";
export var preview = "_6f-c";
export var redoModal = "_6f-2";